import React from 'react'
import { RenderDialogProps } from '../../../legacy-design-system/action/confirmation-action'
import { ConfirmationRoleAction } from '../../../legacy-design-system/action'
import { ModifyAttackEventsTagsDialog } from './tag-dialog'
import { Role } from '@contrast-security-inc/base-types'
import { AttackEventWithTags } from './shared'
import { getInitialTags, TagCount } from '../../../legacy-design-system/tags'
import { IconTag } from '@contrast-security-inc/design-system-foundations'
import { ConfirmationRoleActionProps } from '../../../legacy-design-system/action/confirmation-role-action'

interface TagsActionProps extends Pick<ConfirmationRoleActionProps, 'size'> {
  organizationUuid: string
  attackEvents: AttackEventWithTags[]
  applicationRole?: Role
  showDisabled?: boolean
  bulk?: boolean
  refreshGridData: () => void
}

export function ModifyAttackEventsTagsAction({
  organizationUuid,
  attackEvents,
  applicationRole,
  showDisabled = false,
  bulk = false,
  refreshGridData,
  size
}: TagsActionProps) {
  const tagCount = attackEvents.length === 0 ? 0 : attackEvents[0].tags.length
  const showTagCount = tagCount > 0 && attackEvents.length === 1 && !bulk

  return (
    <ConfirmationRoleAction
      size={size}
      requiredRole="EDIT"
      role={applicationRole || 'VIEW'}
      isActionValid={true}
      iconMetadata={
        showTagCount ? (
          <>
            <TagCount tagCount={tagCount} />{' '}
          </>
        ) : undefined
      }
      icon={IconTag}
      showDisabled={showDisabled}
      hideTooltip={true}
      iconTooltipMessage={{ id: 'action_tag' }}
      disabledTooltipMessage={{
        id: 'detail_attackEvents_insufficientTagPermissions'
      }}
      renderDialog={({ isOpen, closeDialog }: RenderDialogProps) => {
        return (
          <ModifyAttackEventsTagsDialog
            organizationUuid={organizationUuid}
            attackEventIDs={attackEvents.map((attackEvent) => attackEvent.id)}
            closeDialog={closeDialog}
            isOpen={isOpen}
            initialTags={getInitialTags(attackEvents)}
            refreshGridData={refreshGridData}
          />
        )
      }}
    />
  )
}
